import { getFirestore, collection, addDoc, query, orderBy, limit, startAfter, getDocs, Timestamp } from "firebase/firestore";
import { PageCursor } from "../../domain/models/pagination";
import { mapFirebaseError } from "./errorMapper";
import { reportDTOtoDomain } from "./mappers";
export class FirebaseReportsRepository {
    db = getFirestore();
    coll = collection(this.db, "reports");
    async submit(report) {
        try {
            await addDoc(this.coll, {
                reporterId: report.reporterId,
                targetId: report.targetId,
                targetType: report.targetType,
                reason: report.reason,
                createdAt: Timestamp.now(),
                status: "new",
            });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchPage(pageSize, after) {
        try {
            let q = query(this.coll, orderBy("createdAt", "desc"), limit(pageSize));
            if (after?.backing) {
                q = query(q, startAfter(after.backing));
            }
            const snap = await getDocs(q);
            const items = snap.docs.map((d) => ({ id: d.id, ...reportDTOtoDomain(d.id, d.data()) }));
            const nextCursor = snap.docs.length === pageSize ? new PageCursor(snap.docs[snap.docs.length - 1]) : null;
            return { items, nextCursor };
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseReportsRepository.js.map